import { render, staticRenderFns } from "./StarList.vue?vue&type=template&id=2a8798d7&scoped=true"
import script from "./StarList.vue?vue&type=script&lang=js"
export * from "./StarList.vue?vue&type=script&lang=js"
import style0 from "./StarList.vue?vue&type=style&index=0&id=2a8798d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8798d7",
  null
  
)

export default component.exports